<template>
  <div class="page">
    <Apply />
  </div>
</template>

<script>
import Apply from "./components/apply.vue";
export default {
  name: "StudentLeave",
  components: {
    Apply,
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
}
</style>
